module.exports = __webpack_public_path__ + "static/media/buttonclick2.7cdd8ea7.mp3";